import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 px-4 bg-navy-light" data-id="element-145">
      <div className="max-w-4xl mx-auto" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.9
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-br from-gold/20 to-gold/10 border-2 border-gold rounded-2xl p-8 md:p-12 text-center" data-id="element-147">
          <motion.div initial={{
          scale: 0
        }} animate={isInView ? {
          scale: 1
        } : {
          scale: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3,
          type: 'spring'
        }} className="inline-flex items-center justify-center w-20 h-20 bg-gold rounded-full mb-6" data-id="element-148">
            <ShieldCheckIcon className="h-10 w-10 text-navy" aria-hidden="true" data-id="element-149" />
          </motion.div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl mb-6" data-id="element-150">
            Garantía de 30 Días — Sin Preguntas
          </h2>

          <div className="space-y-4 font-body text-lg text-gray-300 mb-6" data-id="element-151">
            <p data-id="element-152">
              Implementa el sistema. Contacta al menos 5 negocios. Si no
              consigues ningún interesado, te devuelvo tu dinero.
            </p>
            <p className="font-semibold text-white" data-id="element-153">
              Sin preguntas, sin burocracia.
            </p>
          </div>

          <p className="font-body text-base text-gold font-semibold" data-id="element-154">
            La única razón por la que ofrezco esta garantía es porque sé que el
            sistema funciona.
          </p>
        </motion.div>
      </div>
    </section>;
}